import React from 'react';
import Select from './Select';
import { planType, dietaryPreference, preferredCuisine } from '../../../context/staticData';


const FreeQuestion = ({handleSelectChange, preSelect}) => {
    const question = [{
        order: 1,
        title: 'Choose a plan that will help you achieve your goal',
        que: planType,
        preSelect: preSelect.planType
    }, {
        order: 2,
        title: 'Select your dietary preference',
        que: [{
            "label": "Vegetarian",
            "value": "veg"
          }, {
            "label": "Non-vegetarian",
            "value": "non_veg"
          }],
        preSelect: preSelect.dietaryPreference
    }, {
        order: 3,
        title: 'Select your preferred cuisine',
        que: [{
            "label": "North - Indian",
            "value": "north_indian"
          }, {
            "label": "South - Indian",
            "value": "south_indian"
          }],
          preSelect: preSelect.preferredCuisine
    }]
    return(
        <>
            { question.map(obj => <Select key={obj.order} handleSelectChange={handleSelectChange} questionData={obj} />) }
        </>
    );
}

export default FreeQuestion;